import React from 'react';
import Logo from '../../assets/seclogoanimado.gif'
import { Container, DivFlexCenter, DivLogo, DivTextAlignCenter, ImageHeader, SecondaryButton, SubmitButton, Subtitle, Title } from '../../styles/styles';
import PoweredBy from '../../assets/powered by@2x.png'
import TicketService from '../../services/TicketService';
import ParametersService from '../../services/ParametersService';
import { IAvulso, ICobranca, IParametros } from '../../types/TicketInterface';
import moment from 'moment';
import { useState } from 'react';

function Ticket() {

  const [payDisabled, setPayDisabled] = useState(true);

  const changePayDisabled = (disabled: boolean) => setPayDisabled(disabled);

  var url_string = window.location.href;
  var url = new URL(url_string);

  var urlHash = url.hash.replace(/%23/g, "#");

  var arrayParameters = urlHash.split('#').slice(1);

  const idToken = arrayParameters[0];
  const idEstacionamento = arrayParameters[1];
  const codigoTicket = arrayParameters[2];

  localStorage.setItem('idToken', idToken);
  localStorage.setItem('idEstacionamento', idEstacionamento);
  localStorage.setItem('codigoTicket', codigoTicket);

  var ticket: IAvulso;
  var cobranca: ICobranca;
  var parametros: IParametros;

  let getTicket = async () => {
    let res = await TicketService.getAvulso(idEstacionamento, codigoTicket, idToken);
    return res.data;
  }

  let getCobranca = async () => {
    let res = await TicketService.postCalculaCobranca(idToken, codigoTicket);
    return res.data;
  }

  let getParametros = async () => {
    let res = await ParametersService.getParameters(idEstacionamento);
    return res.data;
  }

  document.addEventListener("DOMContentLoaded", async function(event) { 

    await getTicket().then(result => {
      ticket = result as IAvulso;
      localStorage.setItem('ticket', JSON.stringify(ticket));
    }).catch(goToError);

    await getCobranca().then(result => {
      cobranca = result as ICobranca;
      localStorage.setItem('cobranca', JSON.stringify(cobranca));
    }).catch(goToError);

    await getParametros().then(result => {
      parametros = result as IParametros;
      localStorage.setItem('parametros', JSON.stringify(parametros));
    }).catch(goToError);

    document.getElementById('codigoTicket')!.innerHTML += ' ' + ticket.strcodigo;
    document.getElementById('horaEntradaTicket')!.innerHTML += ' ' + moment.utc(ticket.datentrada).format('DD/MM/YYYY HH:mm:ss');
    document.getElementById('horaConsultaTicket')!.innerHTML += ' ' + moment().format('DD/MM/YYYY HH:mm:ss');
    document.getElementById('valorTotalTicket')!.innerHTML += ' R$ ' + cobranca.douValorCobrado.toFixed(2).replace('.', ',');
    document.getElementById('valorPagoTicket')!.innerHTML += ' R$ ' + cobranca.douValorPagoAnterior.toFixed(2).replace('.', ',');
    document.getElementById('totalAPagarTicket')!.innerHTML += ' R$ ' + cobranca.douValorCobrado.toFixed(2).replace('.', ',');
    document.getElementById('liberadoAte')!.innerHTML += ' ' + moment.utc(ticket.datsaidaliberada).format('DD/MM/YYYY HH:mm:ss');
    document.getElementById('aposPagamento')!.innerHTML += ' ' + moment.utc(cobranca.datsaidapospgto).format('DD/MM/YYYY HH:mm:ss');
    document.getElementById('nomeEstacionamento')!.innerHTML += ' ' + ticket.regestacionamento.strnome;

    document.getElementById('divTicket')!.style.opacity = '1';

    if(cobranca.douValorCobrado == 0){
      changePayDisabled(true);
    }
    else{
      changePayDisabled(false);
    }
  });

  let goToPayment = () => {
    parametros = JSON.parse(localStorage.getItem('parametros')!) as IParametros;

    if (parametros.opcaoCobranca == 1) {
      window.location.href = '/PayCard';
    } else if (parametros.opcaoCobranca == 2) {
      window.location.href = '/PayPix';
    } else {
      window.location.href = '/Pay';
    }
  }

  let goToViewTicket = () => {
    window.location.href = '/ViewTicket';
  }

  let goToError = () => {
    window.location.href = '/404TK';
  }
  
  return (
    <>
        <DivFlexCenter id='divTicket' style={{opacity: '0'}}>
          <Container className='mt-2 mb-2'>

            <DivTextAlignCenter>
              <ImageHeader src={Logo} />
            </DivTextAlignCenter>

            <hr />

            <DivTextAlignCenter>
              <Title style={{fontFamily: 'Lemon Milk', color: '#CE6B00'}}>
                SECPAY
              </Title>
            </DivTextAlignCenter>

            <Subtitle>
                  Estabelecimento
            </Subtitle>
            <br />
                  <label id='nomeEstacionamento' className='text-muted'>
            </label>

            <br />

            <Subtitle>
              Ticket
            </Subtitle>
            <br />
            <label id='codigoTicket' className='text-muted'>
              Número: 
            </label>

            <hr/>

            <Subtitle>
              Horário
            </Subtitle>
            <br />
            <label id='horaEntradaTicket' className='text-muted'>
              Entrada: 
            </label>
            <br />
            <label id='horaConsultaTicket' className='text-muted'>
              Consulta: 
            </label>

            <hr />

            <Subtitle>
              Tarifa
            </Subtitle>
            <br />
            <label id='valorTotalTicket' className='text-muted'>
              Total: 
            </label>
            <br />
            <label id='valorPagoTicket' className='text-muted'>
              Pago:   
            </label>

            <hr />

            <Subtitle>
              Saída
            </Subtitle>
            <br />
            <label id='liberadoAte' className='text-muted'>
              Liberado até:
            </label>
            <br />
            <label id='aposPagamento' className='text-muted'>
              Após pagamento: 
            </label>

            <hr />

            <Title style={{color: '#444242', fontSize: '1.25em'}} id='totalAPagarTicket'>TOTAL A PAGAR: </Title>

            <div className='mt-3'>
              <SubmitButton disabled={payDisabled} id='btnPagamento' style={{width: '100%', margin: '0 auto 0 auto'}} onClick={goToPayment}>
                IR AO PAGAMENTO
              </SubmitButton>
              
              <SecondaryButton style={{color: '#444242'}} onClick={goToViewTicket}>
                Exibir ticket
              </SecondaryButton>
            </div>

            <hr/>

            <DivTextAlignCenter>
              <img src={PoweredBy} />
            </DivTextAlignCenter>

          </Container>
        </DivFlexCenter>
    </>
  );
}

export default Ticket;
